import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import domainReducer from './domainSlice';
import promptReducer from './promptSlice';
import bpOverviewReducer from './bpOverviewSlice';
import metricsReducer from './metricsSlice';
import contentsReducer from './contentsSlice';
import integrationReducer from './integrationSlice';
import insightsReducer from './insightsSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    domain: domainReducer,
    prompt: promptReducer,
    bpOverview: bpOverviewReducer,
    metrics: metricsReducer,
    contents: contentsReducer,
    integration: integrationReducer,
    insights: insightsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
